import React, { useCallback, useEffect, useState } from 'react'
import Link from 'redux-first-router-link'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser'
import { button } from '@groovehq/internal-design-system/lib/styles/elements'
import logoLight from 'assets/lettermark-light.svg'
import logoChristmasLight from 'assets/lettermark-chrismas-light.png'
import UserItem from 'components/App/DesktopView/Layout/GlobalNav/UserItem'
import { doOpenMainPage } from 'actions/pages'
import { userPlus as UserPlusIcon } from 'assets/icons/groove/v2'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_AGENT_ADD } from 'ducks/drawers/types'
import Search from 'subapps/ticketing/components/TicketList/Header/Search'
import { doFetchBootstrapData } from 'actions/app'
import { isBoostrappedSelector } from 'selectors/app'
import { selectShowAnnualOffer } from 'ducks/billing'
import AnnualOffer from 'components/AnnualOffer'
import { propFunc } from 'util/functions'
import { doSetFlag, selectFlag } from 'ducks/flags'
import { selectIsTestAccount } from 'selectors/account'
import { HIDE_ANNUAL_OFFER } from 'ducks/flags/flagNames'

import IconItem from '../GlobalNav/IconItem'
import OnboardingWorkflow from '../OnboardingWorkflow'
import Help from '../GlobalNav/Help'
import Nav from './Nav'
import { styles } from './styles'
import BurgerMenu from './BurgerMenu'

const toMainPage = doOpenMainPage()
const showChristmasLogo = new Date().getMonth() === 11
const currentLogo = showChristmasLogo ? logoChristmasLight : logoLight

const TopNav = ({ active }) => {
  const dispatch = useDispatch()
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const isAppBootstrapped = useSelector(isBoostrappedSelector)
  const [openAnnualOfferModal, setOpenAnnualOfferModal] = useState(null)
  const shouldAnnualOfferHidden = useSelector(selectFlag)(HIDE_ANNUAL_OFFER)
  const canOpenAnnualOffer =
    openAnnualOfferModal ||
    (openAnnualOfferModal === null && shouldAnnualOfferHidden === false)
  const isTestAccount = useSelector(selectIsTestAccount)
  const showAnnualOffer = useSelector(selectShowAnnualOffer) && !isTestAccount
  const { openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_AGENT_ADD,
    lazyLoad: true,
  })

  const handleAddTeammates = useCallback(
    () => {
      openAddDrawer('new', {
        additionalProps: { title: `Add ${app.t('Agent')}` },
      })
    },
    [openAddDrawer]
  )

  const handleExitAnnualOffer = useCallback(
    () => {
      setOpenAnnualOfferModal(false)
      if (shouldAnnualOfferHidden !== true) {
        dispatch(doSetFlag(HIDE_ANNUAL_OFFER))
      }
    },
    [dispatch, shouldAnnualOfferHidden]
  )

  useEffect(
    () => {
      if (!isAppBootstrapped) {
        dispatch(doFetchBootstrapData())
      }
    },
    [dispatch, isAppBootstrapped]
  )

  const annualOfferOpen = showAnnualOffer && canOpenAnnualOffer

  return (
    <>
      {showAnnualOffer && (
        <AnnualOffer
          // Will set the feature flag if called onExit
          onExit={handleExitAnnualOffer}
          onClose={propFunc(setOpenAnnualOfferModal, false)}
          open={annualOfferOpen}
        />
      )}
      <div css={styles.base} data-test-id="TopNav">
        <Link
          css={[styles.logo, showChristmasLogo && styles.christmasLogo]}
          to={toMainPage}
        >
          <img src={currentLogo} alt="logo" />
        </Link>
        <BurgerMenu className="grui mx-5" active={active} />
        <Nav className="grui mx-5" active={active} css={styles.navMenu} />
        <div className="grui flex items-center flex-1 pr-12">
          <Search
            className="grui mr-16"
            css={styles.search}
            placeholder={`Search your ${app.t('mailbox')}…`}
          />
          <div className="grui ml-auto flex items-center">
            <OnboardingWorkflow.ProgressIndicator className="grui mr-6" />
            {showAnnualOffer && (
              <button
                type="button"
                onClick={propFunc(setOpenAnnualOfferModal, true)}
                className="grui px-4 py-2 mr-4"
                css={[button.styles.preflight, styles.present]}
              >
                🎁
              </button>
            )}
            {isManager && (
              <IconItem onClick={handleAddTeammates}>
                <UserPlusIcon />
              </IconItem>
            )}
            <Help />
            <UserItem />
          </div>
        </div>
      </div>
    </>
  )
}

export default React.memo(TopNav)
